module.exports = __webpack_public_path__ + "img/icon61.ace59790.png";